import React from "react";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import { Form, Field } from "react-final-form";
import { useDispatch } from "react-redux";
import Parse from "parse";
import {
  ImageInput,
  ImageField,
  useNotify,
  fetchStart,
  fetchEnd,
  useRedirect,
} from "react-admin";
import CircularProgress from "@material-ui/core/CircularProgress";
import { TextField, Typography, Button } from "@material-ui/core";

const Dialogstyles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(Dialogstyles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export default function AddOfferDialog() {
  const [open, setOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const redirectTo = useRedirect();
  const dispatch = useDispatch();
  const notify = useNotify();

  const handleClose = () => {
    setOpen(false);
    redirectTo("/myoffers");
  };

  const handleSubmit = async (response) => {
    console.log("response", response);
    const ParseBase64 = await toBase64(
      response.hasOwnProperty("offerImage") ? response.offerImage.rawFile : ""
    );

    console.log("ParseBase64", ParseBase64);
    response.offerImage = ParseBase64;
    try {
      dispatch(fetchStart());
      setLoading(true);

      const Offer = await Parse.Cloud.run("CreateOffer", {
        response: response,
      });
      if (Offer) {
        redirectTo("/myoffers");
        notify(
          "Offer created, Will be displayed here once approved by the admin"
        );
        dispatch(fetchEnd());
        setLoading(false);
        setOpen(false);
      } else {
        redirectTo("/myoffers");
        // notify("Offer created, Will be displayed here once approved by admin");
        dispatch(fetchEnd());
        setLoading(false);
        setOpen(false);
      }
    } catch (e) {
      notify(e.message, "warning");
      console.log("tHE ERRIR------->", e);
      setLoading(false);
      setOpen(false);
      redirectTo("/myoffers");
    } finally {
      dispatch(fetchEnd());
      setLoading(false);
      setOpen(false);
      redirectTo("/myoffers");
    }
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        open={open}
      >
        <DialogTitle
          style={{
            textAlign: "center",
          }}
          onClose={handleClose}
        >
          Add Your Certificates
        </DialogTitle>
        <Form
          onSubmit={handleSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <DialogContent
                dividers
                style={{
                  margin: "2vh",
                  padding: "5vh",
                }}
              >
                <Field name="offerImage">
                  {(props) => (
                    <div>
                      <ImageInput
                        source="offerImage"
                        label="Offer Image"
                        accept="image/*"
                        labelSingle="Select Offer Image to Upload"
                      >
                        <ImageField source="src" title="title" />
                      </ImageInput>{" "}
                    </div>
                  )}
                </Field>
                <Field name="offerTitle">
                  {(props) => (
                    <div>
                      <TextField
                        style={{
                          marginBottom: "2vh",
                        }}
                        fullWidth
                        id="outlined-basic"
                        label="Offer Title"
                        name={props.input.name}
                        value={props.input.value}
                        onChange={props.input.onChange}
                        variant="outlined"
                      />
                    </div>
                  )}
                </Field>

                <Field name="offerDescription">
                  {(props) => (
                    <div>
                      <TextField
                        style={{
                          marginBottom: "2vh",
                        }}
                        fullWidth
                        id="outlined-basic"
                        label="Offer Description"
                        variant="outlined"
                        name={props.input.name}
                        value={props.input.value}
                        onChange={props.input.onChange}
                      />
                    </div>
                  )}
                </Field>
              </DialogContent>

              <DialogActions>
                <Button autoFocus onClick={handleClose} color="secondary">
                  Cancel
                </Button>

                <Button autoFocus type="submit" color="primary">
                  {loading ? <CircularProgress /> : "Save"}
                </Button>
              </DialogActions>
            </form>
          )}
        />
      </Dialog>
    </div>
  );
}
